<rid-demo-page [title]="'Games'" previousRoute="/mechanics">
  <rid-button class="w-full" content="Memory" variant="PRIMARY" routerLink="memory-match" />
  <rid-button class="w-full" content="Klanko" variant="PRIMARY" routerLink="klanko" />
</rid-demo-page>
